/**
 * voteManage接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const voteManage = {
  /** 投票维护 */
  getVoteInfo (params) {
    return axios.get('/api/voteManage/GetVoteInfo', { params })
  },
  getVoteBasicInfo (params) {
    return axios.get('/api/voteManage/GetVoteBasicInfo', { params })
  },
  getVoteProjectInfo (params) {
    return axios.get('/api/voteManage/GetVoteProjectInfo', { params })
  },
  getVoteUserInfo (params) {
    return axios.get('/api/voteManage/GetVoteUserInfo', { params })
  },
  getPublicVoteBasicInfo (params) {
    return axios.get('/api/voteManage/GetPublicVoteBasicInfo', { params })
  },
  editVote (params) {
    return axios.post('/api/voteManage/EditVote', params)
  },
  editVoteBasic (params) {
    return axios.post('/api/voteManage/EditVoteBasic', params)
  },
  editVoteProject (params) {
    return axios.post('/api/voteManage/EditVoteProject', params)
  },
  adjustVoteProject (params) {
    return axios.post('/api/voteManage/AdjustVoteProject', params)
  },
  editVoteUser (params) {
    return axios.post('/api/voteManage/EditVoteUser', params)
  },
  editPublicVoteBasic (params) {
    return axios.post('/api/voteManage/EditPublicVoteBasic', params)
  },
  adjustVoteUser (params) {
    return axios.post('/api/voteManage/AdjustVoteUser', params)
  },
  deleteVote (params) {
    return axios.delete('/api/voteManage/DeleteVote', { params })
  },
  clearMeetingData (params) {
    return axios.post('/api/voteManage/ClearMeetingData', params)
  },
  sortVote (params) {
    return axios.post('/api/voteManage/SortVote', params)
  },
  quickCreateVote (params) {
    return axios.post('/api/voteManage/QuickCreateVote', params)
  },
  completeAllVote (params) {
    return axios.post('/api/voteManage/CompleteAllVote', params)
  },
  openUpgradeGroupRanking (params) {
    return axios.post('/api/voteManage/OpenUpgradeGroupRanking', params)
  },
  /** 投票查询 */
  // 获取投票列表
  getVoteList (params) {
    return axios.get('/api/voteManage/getVoteList', { params })
  },
  getPrizeVotes (params) {
    return axios.get('/api/voteManage/GetPrizeVotes', { params })
  },
  getNotEditVotes (params) {
    return axios.get('/api/voteManage/GetNotEditVotes', { params })
  },
  /** 管理投票状态 */
  checkVoteInfo (params) {
    return axios.post('/api/voteManage/CheckVoteInfo', params)
  },
  startVote (params) {
    return axios.post('/api/voteManage/StartVote', params)
  },
  startPublicVote (params) {
    return axios.post('/api/voteManage/StartPublicVote', params)
  },
  endVote (params) {
    return axios.post('/api/voteManage/EndVote', params)
  },
  endPublicVote (params) {
    return axios.post('/api/voteManage/EndPublicVote', params)
  },
  colseVote (params) {
    return axios.post('/api/voteManage/ColseVote', params)
  },
  resetVote (params) {
    return axios.post('/api/voteManage/ResetVote', params)
  },
  resetPublicVote (params) {
    return axios.post('/api/voteManage/ResetPublicVote', params)
  },
  editScreenFlow (params) {
    return axios.post('/api/voteManage/EditScreenFlow', params)
  },
  editShortlistedScreenFlow (params) {
    return axios.post('/api/voteManage/EditShortlistedScreenFlow', params)
  },
  eidtQuickCreateVote (params) {
    return axios.post('/api/voteManage/EidtQuickCreateVote', params)
  },
  removeVoteUser (params) {
    return axios.post('/api/voteManage/RemoveVoteUser', params)
  },
  addVoteUser (params) {
    return axios.post('/api/voteManage/AddVoteUser', params)
  },
  /** 投票结果监控 */
  getVoteResultRanking (params) {
    return axios.get('/api/voteManage/GetVoteResultRanking', { params })
  },
  getVoteResult (params) {
    return axios.get('/api/voteManage/GetVoteResult', { params })
  },
  editVoteResultSort (params) {
    return axios.post('/api/voteManage/EditVoteResultSort', params)
  },
  editVoteResultBaseNumber (params) {
    return axios.post('/api/voteManage/EditVoteResultBaseNumber', params)
  },
  getVoteProgress (params) {
    return axios.get('/api/voteManage/GetVoteProgress', { params })
  },
  getVoteProgressInfo (params) {
    return axios.get('/api/voteManage/GetVoteProgressInfo', { params })
  },
  checkVote (params) {
    return axios.post('/api/voteManage/CheckVote', params)
  },
  checkPublicVote (params) {
    return axios.post('/api/voteManage/CheckPublicVote', params)
  },
  getVoteDetail (params) {
    return axios.get('/api/voteManage/GetVoteDetail', { params })
  },
  getVoteDetailUsers (params) {
    return axios.get('/api/voteManage/GetVoteDetailUsers', { params })
  },
  getVoteDetailProjects (params) {
    return axios.get('/api/voteManage/GetVoteDetailProjects', { params })
  },
  getVoteDetailByProjects (params) {
    return axios.get('/api/voteManage/GetVoteDetailByProjects', { params })
  },
  getVoteDetailByUsers (params) {
    return axios.get('/api/voteManage/GetVoteDetailByUsers', { params })
  },
  getVoteDetails (params) {
    return axios.get('/api/voteManage/getVoteDetails', { params })
  },
  exportVoteDetailByProjects (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteDetailByProjects',
      data: params,
      responseType: 'blob'
    })
  },
  exportVoteDetailByUsers (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteDetailByUsers',
      data: params,
      responseType: 'blob'
    })
  },
  exportVoteDetailsByProjects (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteDetailsByProjects',
      data: params,
      responseType: 'blob'
    })
  },
  exportVoteDetailsByUsers (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteDetailsByUsers',
      data: params,
      responseType: 'blob'
    })
  },
  againVote (params) {
    return axios.post('/api/voteManage/AgainVote', params)
  },
  submitShortlistedVote (params) {
    return axios.post('/api/voteManage/SubmitShortlistedVote', params)
  },
  getVoteResults (params) {
    return axios.get('/api/voteManage/GetVoteResults', { params })
  },
  exportVoteResult (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteResult',
      data: params,
      responseType: 'blob'
    })
  },
  exportVoteResults (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteResults',
      data: params,
      responseType: 'blob'
    })
  },
  getRuleItemsByRuleId (params) {
    return axios.get('/api/voteManage/GetRuleItemsByRuleId', { params })
  },
  getVoteScoreDetails (params) {
    return axios.get('/api/voteManage/GetVoteScoreDetails', { params })
  },
  getVoteQADetails (params) {
    return axios.get('/api/voteManage/GetVoteQADetails', { params })
  },
  getVoteWJDetails (params) {
    return axios.get('/api/voteManage/GetVoteWJDetails', { params })
  },
  exportVoteScoreDetails (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteScoreDetails',
      data: params,
      responseType: 'blob'
    })
  },
  exportVoteRuleItemScore (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteRuleItemScore',
      data: params,
      responseType: 'blob'
    })
  },
  exportVoteQADetails (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteQADetails',
      data: params,
      responseType: 'blob'
    })
  },
  exportVoteWJDetails (params) {
    return axios({
      method: 'post',
      url: '/api/voteManage/ExportVoteWJDetails',
      data: params,
      responseType: 'blob'
    })
  }
}

export default voteManage
